"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDefaultProps = void 0;

var _propTypes = require("prop-types");

const withDefaultProps = (propTypes, defaultProps) => {
  return ForwardRef => {
    ForwardRef.propTypes = {
      component: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.elementType]),
      className: _propTypes.string,
      'data-testid': _propTypes.string,
      withRef: _propTypes.object,
      ...propTypes
    };
    ForwardRef.defaultProps = {
      component: 'div',
      ...defaultProps
    };
    return ForwardRef;
  };
};

exports.withDefaultProps = withDefaultProps;